import { Grid, List, ListItemButton, Typography } from '@mui/material'
import { CustomerAccountPaymentModel } from './CustomerAccountsPaymentMobile'
import MonetaryFormat from 'components/MonetaryFormat/MonetaryFormat'
import { printCustomerName } from 'components/CustomerAdmin/utils'

interface CustomerPaymentListProps {
    customers: CustomerAccountPaymentModel[]
    selectCustomerID: string | undefined
    /**double click on list */
    assignToOrder: (customerID: string) => void
    setSelectCustomer: (customerID: string) => void
}

function CustomerAccountMainList({
    customers: customerAccounts,
    selectCustomerID,
    assignToOrder,
    setSelectCustomer,
}: CustomerPaymentListProps) {
    return (
        <div
            style={{
                height: 'calc(75svh - 200px)',
                overflowY: 'auto',
            }}
        >
            <List component="nav">
                {customerAccounts.map((cus, index) => (
                    <ListItemButton
                        disabled={!cus.isActive}
                        key={index + '-customer-account'}
                        selected={cus.customer?.customerID === selectCustomerID}
                        onClick={() => {
                            setSelectCustomer(cus.customer?.customerID!!)
                        }}
                        onDoubleClick={() => {
                            setSelectCustomer(cus.customer?.customerID!!)
                            assignToOrder(cus.customer?.customerID!!)
                        }}
                        sx={{
                            display: 'block',
                            marginBottom: 1,
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                            justifyContent={'space-between'}
                        >
                            <Grid item>
                                <Typography variant="h6" pb={1}>
                                    {`Account: ${cus.name ?? ''}`}
                                </Typography>
                                <Typography variant="body1">
                                    {`Owner : ${printCustomerName(
                                        cus.customer,
                                    )}`}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <MonetaryFormat
                                    variant="h6"
                                    value={cus.accountBalance ?? 0}
                                />
                            </Grid>
                        </Grid>
                    </ListItemButton>
                ))}
            </List>
        </div>
    )
}

export default CustomerAccountMainList
